import action from '../helpers/rest-client'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewSupportTaskOutDto,
  EditSupportTaskOutDto,
  DeleteSupportTaskOutDto,
  GetOneSupportTaskOutDto,
  GetAllSupportTasksOutDto,
} from '../types/support-tasks.dto'

export class ErrorSupportTask extends Error { }

const path = '/support-tasks'

class SupportTasks {
  public new(payload: NewSupportTaskOutDto) {
    console.log('SupportTask new:', payload)
    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public edit({ idSupportTask, ...rest }: EditSupportTaskOutDto) {
    return action
      .Put({
        url: `${path}/${idSupportTask}`,
        body: rest,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getAll({ filters, pagination, sort }: GetAllSupportTasksOutDto) {
    const filtersJSON = filters ? `&filters=${JSON.stringify(filters)}` : '';

    return action
      .Get({
        url: `${path}${paginationString({ pagination, sort })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getOne({ idSupportTask }: GetOneSupportTaskOutDto) {
    return action
      .Get({
        url: `${path}/${idSupportTask}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public deleteOne({ idSupportTask }: DeleteSupportTaskOutDto) {
    return action
      .Del({
        url: `${path}/${idSupportTask}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const supportTasks = new SupportTasks()
export default supportTasks
